import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Hero from "@/components/home/Hero";
import Board from "@/components/home/Board";
import HomePicks from "@/components/home/HomePicks";
import FeaturedFreePick from "@/components/home/FeaturedFreePick";
import HomeResults from "@/components/home/HomeResults";
import Features from "@/components/home/Features";
import AnalysisDemo from "@/components/home/AnalysisDemo";
import Pricing from "@/components/home/Pricing";
import Steps from "@/components/home/Steps";
import Community from "@/components/home/Community";
import FinalCta from "@/components/home/FinalCta";

export default function Home() {
  const navigate = useNavigate();
  const scrollToPricing = useCallback(() => {
    const el = document.getElementById("pricing");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#pricing");
    }
  }, [navigate]);

  return (
    <div data-testid="home-page">
      <Hero />
      <FeaturedFreePick />
      <HomePicks onUnlock={scrollToPricing} />
      <HomeResults />
      <Pricing />
      <Board />
      <Features />
      <AnalysisDemo onUnlock={scrollToPricing} />
      <Steps />
      <Community />
      <FinalCta />
    </div>
  );
}
